import { Collapse } from "@material-ui/core";

export default Collapse;
